import React, { Component } from "react";
import EligibilityCheck from "./EligibilityCheck";
import MemberDetail from "../memberSearch/memberDetails";
import { addTab } from "./../../store/broadcaster/BroadcastRegister";
import { Tabs } from "antd";
import Config from "../../config";

//const { TabPane } = Tabs;
const fromWhere = "Check Eligibility";

export default class Searchdashboard extends Component {
  subscribe;
  constructor(props) {
    super(props);
    this.newTabIndex = 0;
    // this.state = {
    //   fromWhere: "Check Eligibility",
    // };
    const panes = [
      {
        title: "Member Search",
        content: <EligibilityCheck />,
        key: "1",
        closable: false,
      },
    ];
    this.state = {
      activeKey: panes[0].key,
      panes,
      TabButtons: null
    };
    this.subscribe = addTab.subscribe((tabInfo) => {
      if (tabInfo === null) return;
      else this.add(tabInfo);
    });
  }

  onChange = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };
  //test

  add = (tabDetails) => {
    if (tabDetails.item != undefined) {
      const { panes } = this.state;
      let activeKey;
      const currentIndex = panes.findIndex((pane) =>
        pane.title.includes(tabDetails.item.SubscriberID)
      );
      if (currentIndex === -1) {
        activeKey = `newTab${this.newTabIndex++}`;
        switch (tabDetails.type) {
          case "membertype":
            panes.push({
              title: "SID: " + tabDetails.item.SubscriberID,
              content: (
                <MemberDetail data={tabDetails.item} fromPage={fromWhere} />
              ),
              key: activeKey,
            });
            break;
          // console.error("Invalid Episode Id");
        }
      } else {
        activeKey = panes[currentIndex].key;
      }
      this.setState({ panes, activeKey });
    }
  };

  remove = (targetKey) => {
    const { panes, activeKey } = this.state;
    let newActiveKey = activeKey;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newPanes = panes.filter((pane) => pane.key !== targetKey);
    if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = newPanes[lastIndex].key;
      } else {
        newActiveKey = newPanes[0].key;
      }
    }
    this.setState({
      panes: newPanes,
      activeKey: newActiveKey,
    });
  };
  componentDidMount(){
    if(sessionStorage.getItem("planName") === 'solis'){
      var windowDimensions = "height="+window.screen.height+",width="+window.screen.width
      this.setState({
        TabButtons:
        <div className="tab-button-container">
          <button onClick={() => {
            window.open(
              Config.OTC,
              "OTC Portal",
              windowDimensions
            );
          }}>OTC Portal</button>
          <button onClick={() => {
            window.open(
              Config.CalypsoLite,
              "Calypso Lite",
              windowDimensions
            );
          }}>Calypso Lyte</button>
          <button onClick={() => {
            window.open(
              Config.EnsureDataSolutions,
              "Ensure Data Solutions",
              windowDimensions
            );
          }}>Ensure Data Solutions</button>
          <button onClick={() => {
            window.open(
              Config.SolisHealthPlan,
              "Solis Health Plan",
              windowDimensions
            );
          }}>Solis Health Plans</button>
        </div>        
      });
    }
  }

  render() {
    return (
      <Tabs
        tabBarExtraContent= {this.state.TabButtons}
        onChange={this.onChange}
        activeKey={this.state.activeKey}
        type="editable-card"
        onEdit={this.onEdit}
        items={this.state.panes.map((pane) => {
          return {
            label : pane.title,
            key: pane.key,
            closable: pane.closable,
            children: pane.content
          }
        })}
      >
        {/* {this.state.panes.map((pane) => (
          <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
            {pane.content}
          </TabPane>
        ))} */}
      </Tabs>      
    );
  }
}
